module.exports = __webpack_public_path__ + "img/b1dc76e.png";